export const Defaults = {
    Microsoft: {
        SOCIAL_PROVIDER: "Microsoft",
    },
    FormInvalidMessage: "Please fix the errors above.",
    JobCategory: {
        AllJobCategories: {
            JOB_CATEGORY_ID: 100,
            JOB_CATEGORY_NAME: "All",
        },
        Recruiter: {
            JOB_CATEGORY_ID: 10,
            JOB_CATEGORY_NAME: "Recruiter",
        },
    },
    JobPosition: {
        AllJobPositions: {
            JOB_CATEGORY_NAME: "All",
            JOB_POSITION_ID: 10000,
            JOB_POSITION_NAME: "All job categories",
        },
    },
    Location: {
        AnyLocation: {
            LOCATION_ID: 1,
            LOCATION_NAME: "Any location",
        },
    },
    Search: {
        SEO_DEFAULT_JOB_CATEGORY: "All",
    },
    FileCategoryType: {
        Unknown: 0,
        Attachment: 10,
        FormattedResume: 20,
        JobCover: 30,
        UserProfile: 40,
        OriginalResume: 50,
        Recording: 60,
    },
    DistanceOptions: [
        { value: "1", label: "exact location only" },
        { value: "5", label: "within 5 miles" },
        { value: "10", label: "within 10 miles" },
        { value: "25", label: "within 25 miles" },
        { value: "50", label: "within 50 miles" },
        { value: "100", label: "within 100 miles" },
        { value: "250", label: "within 250 miles" },
    ],
};
